import { digitsFaToEn } from '@persian-tools/persian-tools';
import moment from 'moment-jalaali';

import { persianMonth } from './persianMonth';

export function durationTour(
  nStart: number | undefined,
  nEnd: number | undefined
) {
  if (nStart === undefined) {
    return '';
  }

  let startMonth = persianMonth(nStart);
  let startDay = moment(nStart).format('jD');
  let endDay = nEnd ? moment(nEnd).format('jD') : '';

  if (nEnd && nEnd !== 0) {
    let endMonth = persianMonth(nEnd);
    if (endMonth === startMonth) {
      if (endDay === startDay) {
        return ` ${startDay} ${startMonth}`;
      }
      return ` ${startDay} تا ${endDay} ${endMonth}`;
    } else {
      return `${startDay} ${startMonth} تا ${endDay} ${endMonth}`;
    }
  } else {
    return `${startDay} ${startMonth}`;
  }
}

export function DaysMember(
  nStart: number | undefined,
  nEnd: number | undefined
) {
  if (nStart === undefined || nEnd === undefined) {
    return 1;
  }

  let difference = nEnd - nStart;
  let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
  if (TotalDays <= 0) {
    return 0;
  }
  return TotalDays;
}
